import { deleteAccountRequest } from 'api/Account/api';

import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useDeleteAccount = (onSuccessfulSubmit: () => void) => {
  const { t } = useTranslation();

  const [ isSubmitting, setSubmitting ] = useState(false);
  const [ submitError, setSubmitError ] = useState<string>();

  const deleteAccount = useCallback((accountId: string) => {
    setSubmitting(true);
    setSubmitError('');

    deleteAccountRequest(accountId)
      .then(() => {
        onSuccessfulSubmit();
      })
      .catch(error => setSubmitError(error?.response?.data?.message || t('errors.server_error_try_again')))
      .finally(() => setSubmitting(false));
  }, [ t, onSuccessfulSubmit ]);

  return {
    deleteAccount,
    isSubmitting,
    submitError,
  };
};
